import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../ui/theme/colors';

export const useLockerTimelineGroupStyles = makeStyles((theme) => ({
  sessionWrapper: {
    position: 'relative'
  },
  deliveryWrapper: {
    position: 'relative'
  },
  sessionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0',
    paddingLeft: '2rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px'
    }
  },
  sessionHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  sessionUserName: {
    fontSize: '15px',
    fontWeight: 600,
    color: 'black'
  },
  deliveryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '4px',
    padding: '8px 0 16px 0',
    paddingLeft: '2rem'
  },
  groupIcon: {
    width: '24px',
    height: '24px',
    color: Colors.timelineGray
  },
  sessionLabel: {
    fontSize: '12px',
    color: Colors.timelineGray
  },
  deliveryLabel: {
    fontSize: '12px',
    color: 'black',
    fontWeight: 600
  },
  deliveryLink: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '15px',
    color: 'black',
    fontWeight: 600,
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'underline !important'
    }
  },
  disabledDeliveryLink: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '15px',
    color: Colors.midGray,
    fontWeight: 600,
    cursor: 'default'
  },
  chevronIcon: {
    fontSize: '18px',
    color: Colors.midGray
  },
  eventRowWrapper: {
    '& > div > div:first-child': {
      marginBottom: 0
    },
    '& .MuiPaper-root': {
      boxShadow: 'none !important',
      filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))'
    }
  },
  ungroupedSpacer: {
    paddingTop: '16px'
  },
  solidDivider: {
    marginRight: '-2rem',
    paddingLeft: 'calc(2rem - 3px)',
    borderBottom: `1px solid ${Colors.midLightGray}`
  },
  dashedDivider: {
    marginRight: '-2rem',
    paddingLeft: 'calc(2rem - 3px)',
    borderBottom: `1px dashed ${Colors.midLightGray}`
  }
}));
